import f00 from '@lunary/app-core/cards/00.webp'
import f01 from '@lunary/app-core/cards/01.webp'
import f02 from '@lunary/app-core/cards/02.webp'
import f03 from '@lunary/app-core/cards/03.webp'
import f04 from '@lunary/app-core/cards/04.webp'
import f05 from '@lunary/app-core/cards/05.webp'
import f06 from '@lunary/app-core/cards/06.webp'
import f07 from '@lunary/app-core/cards/07.webp'
import f08 from '@lunary/app-core/cards/08.webp'
import f09 from '@lunary/app-core/cards/09.webp'
import f10 from '@lunary/app-core/cards/10.webp'
import f11 from '@lunary/app-core/cards/11.webp'
import f12 from '@lunary/app-core/cards/12.webp'
import f13 from '@lunary/app-core/cards/13.webp'
import f14 from '@lunary/app-core/cards/14.webp'
import f15 from '@lunary/app-core/cards/15.webp'
import f16 from '@lunary/app-core/cards/16.webp'
import f17 from '@lunary/app-core/cards/17.webp'
import f18 from '@lunary/app-core/cards/18.webp'
import f19 from '@lunary/app-core/cards/19.webp'
import f20 from '@lunary/app-core/cards/20.webp'
import f21 from '@lunary/app-core/cards/21.webp'

function faceUrl(asset: unknown): string {
  if (typeof asset === 'string') return asset
  if (typeof asset === 'object' && asset !== null && 'src' in asset && typeof asset.src === 'string') return asset.src
  return ''
}

const FACES: readonly string[] = [
  f00, f01, f02, f03, f04, f05, f06, f07, f08, f09, f10,
  f11, f12, f13, f14, f15, f16, f17, f18, f19, f20, f21,
].map(faceUrl)

export function cardFace(number: number): string | null {
  return FACES[number] ?? null
}
